import { GraphQLResult } from '@aws-amplify/api-graphql';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { API, graphqlOperation } from 'aws-amplify';
import { User } from '../../reduxRepositories/users/users.interfaces';

// This type describes the error object structure:
// type GetAppUserError = {
//   message: string;
// };

export const getAppUserThunk = createAsyncThunk<
  User,
  string
  // { rejectValue: GetAppUserError }
>('auth/getAppUserThunk', async (payload, thunkApi) => {
  try {
    const result = (await API.graphql(
      graphqlOperation(
        `query MyQuery {
          getUser(id: "${payload}") {
            id
            accountId
            accountType
            email
            phone
            firstName
            lastName
            enabled
            role
            createdByUserId
            inviteEmailStatus
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
          }
        }`,
      ),
    )) as GraphQLResult<{ getUser: User }>;

    if (!result?.data) {
      return thunkApi.rejectWithValue({
        message: 'user not found',
      });
    }

    const appUser = result.data.getUser;
    // console.log('appUser: ', appUser);
    return appUser;
  } catch (error) {
    return thunkApi.rejectWithValue({
      message: error,
    });
  }
});
